import React from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { IoIosArrowForward } from "react-icons/io";
import { FaRegMessage } from "react-icons/fa6";
import { TbBrandGoogleFilled } from "react-icons/tb";
import { FaWhatsapp } from "react-icons/fa";

import CampaignReport from './CampaignReport';
import DeliveryReport from './DeliveryReport';
import ScheduleReport from './ScheduleReport';
import FallbackReport from './FallbackReport';
import ApiReport from './ApiReport';


function CampaignActivity() {

    const [activeTab, setActiveTab] = useState("CampaignReport");

    const tabList = [
        {
            id: "CampaignReport", label: " Campaign Reportas", icon: <FaRegMessage />
            , component: <CampaignReport />
        }, 
        {
            id: "DeliveryReport", label: "Delivery Report", icon: <TbBrandGoogleFilled />
            , component: <DeliveryReport/>
        },
        {
            id: "ScheduleReport", label: " Schedule Report", icon: <FaWhatsapp />
            , component: <ScheduleReport/>
        }
        ,
        {
            id: "FallbackReport", label: " Fallback Report", icon: <FaWhatsapp />
            , component: <FallbackReport/>
        }
        ,
        {
            id: "APIReport", label: " API Report", icon: <FaWhatsapp />
            , component: <ApiReport/>
        }

    ];
    return (
        <div className='dark:bg-[#121519]  px-4'>
            <div className='border-b-[1px] border-[#cfcdcd] pb-1 flex items-center gap-2 '>
                <Link to='/Report'>
                    <FaArrowLeftLong className='text-[20px] dark:text-[#fff]' />
                </Link>
                <div>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Campaign Activity</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward /> <span>Campaign Activity</span>  </div>
                </div>
            </div>
            <div className=' w-[100%] flex gap-1 px-2 pt-4  '>
                {tabList.map((item, index) =>
                    <button
                        onClick={() => setActiveTab(item.id)}
                        className={` w-[32%] rounded-[5px]  py-2 text-[11px] font-bold flex items-center justify-center gap-1 ${activeTab === item.id ? 'bg-[#37715d] text-[#fff]' : 'bg-[#e0e0e0] text-[#333]'} `} > {item.icon}  <span className='md:block hidden'>{item.label}</span>  </button>
                )
                }
            </div>
            <div className="pt-4 px-2 dark:bg-[#121519]">
                {tabList.find((t) => t.id === activeTab)?.component}
            </div>
        </div>

    )
}

export default CampaignActivity

